import {Injectable} from '@angular/core';
import {Action, Store} from '@ngrx/store';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromRoot from '../../../../state/app.state';
import {CommonService} from '../../../shared/services/common.service';
import {ProgressService} from './progress.service';
import {Observable, of} from 'rxjs';
import {catchError, map, mergeMap, tap} from 'rxjs/operators';
import {
  FetchBmiChartDataFailure,
  FetchBmiChartDataRequest,
  FetchBmiChartDataSuccess,
  FetchBmiChartTableDataFailure,
  FetchBmiChartTableDataRequest,
  FetchBmiChartTableDataSuccess,
  FetchBmiGoalFilterDataFailure,
  FetchBmiGoalFilterDataRequest,
  FetchBmiGoalFilterDataSuccess,
  FetchAdultBmiGoalFilterDataFailure,
  FetchAdultBmiGoalFilterDataRequest,
  FetchAdultBmiGoalFilterDataSuccess,
  FetchDailyFoodChartDataFailure,
  FetchDailyFoodChartDataRequest,
  FetchDailyFoodChartDataSuccess,
  FetchDailyPAChartDataFailure,
  FetchDailyPAChartDataRequest,
  FetchDailyPAChartDataSuccess,
  FetchDailySTChartDataFailure,
  FetchDailySTChartDataRequest,
  FetchDailySTChartDataSuccess,
  FetchHeightChartDataFailure,
  FetchHeightChartDataRequest,
  FetchHeightChartDataSuccess,
  FetchHeightChartTableDataFailure,
  FetchHeightChartTableDataRequest,
  FetchHeightChartTableDataSuccess,FetchJournalChartDataFailure, FetchJournalChartDataRequest, FetchJournalChartDataSuccess, FetchJournalChartTableDataFailure, FetchJournalChartTableDataRequest, FetchJournalChartTableDataSuccess, FetchPATableDataFailure,
  FetchPATableDataRequest,
  FetchPATableDataSuccess,
  FetchSTTableDataFailure,
  FetchSTTableDataRequest,
  FetchSTTableDataSuccess,
  FetchWeeklyFoodChartDataFailure,
  FetchWeeklyFoodChartDataRequest,
  FetchWeeklyFoodChartDataSuccess,
  FetchWeeklyFoodChartTableDataFailure,
  FetchWeeklyFoodChartTableDataRequest,
  FetchWeeklyFoodChartTableDataSuccess, FetchWeeklyPAChartDataFailure,
  FetchWeeklyPAChartDataRequest,
  FetchWeeklyPAChartDataSuccess,
  FetchWeeklySTChartDataFailure, FetchWeeklySTChartDataRequest,
  FetchWeeklySTChartDataSuccess,
  FetchWeightChartDataFailure,
  FetchWeightChartDataRequest,
  FetchWeightChartDataSuccess,
  FetchWeightChartTableDataFailure,
  FetchWeightChartTableDataRequest,
  FetchWeightChartTableDataSuccess
} from './progress.actions';
import {PrintService} from '../../../shared/services/print.service';

@Injectable()
export class ProgressEffects {

  fetchHeightChartData$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchHeightChartDataRequest),
      map((action) => {
        return action;
      }),
      mergeMap(({payload, forPrint}) =>
        this.apiService.fetchHeightChartData(payload).pipe(
          map((response) => {
            const {data, message} = response;
            return FetchHeightChartDataSuccess({
              data,
              message,
            });
          }),
          catchError(() => {
            return of(FetchHeightChartDataFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchHeightChartDataSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchHeightChartDataFailure.type) {
              if (forPrint) {
                this.printService.stop();
              }
            }
          })
        )
      )
    )
  );

  fetchHeightChartTableData$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchHeightChartTableDataRequest),
      map((action) => {
        return action;
      }),
      mergeMap(({payload, forPrint}) =>
        this.apiService.fetchHeightChartTableData(payload).pipe(
          map((response) => {
            const {data, message} = response;
            return FetchHeightChartTableDataSuccess({
              data,
              message,
            });
          }),
          catchError(() => {
            return of(FetchHeightChartTableDataFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchHeightChartTableDataSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchHeightChartTableDataFailure.type) {
              if (forPrint) {
                this.printService.stop();
              }
            }
          })
        )
      )
    )
  );

  fetchWeightChartData$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchWeightChartDataRequest),
      map((action) => {
        return action;
      }),
      mergeMap(({payload, forPrint}) =>
        this.apiService.fetchWeightChartData(payload).pipe(
          map((response) => {
            const {data, message} = response;
            return FetchWeightChartDataSuccess({
              data,
              message,
            });
          }),
          catchError(() => {
            return of(FetchWeightChartDataFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchWeightChartDataSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchWeightChartDataFailure.type) {
              if (forPrint) {
                this.printService.stop();
              }
            }
          })
        )
      )
    )
  );

  fetchWeightChartTableData$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchWeightChartTableDataRequest),
      map((action) => {
        return action;
      }),
      mergeMap(({payload, forPrint}) =>
        this.apiService.fetchWeightChartTableData(payload).pipe(
          map((response) => {
            const {data, message} = response;
            return FetchWeightChartTableDataSuccess({
              data,
              message,
            });
          }),
          catchError(() => {
            return of(FetchWeightChartTableDataFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchWeightChartTableDataSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchWeightChartTableDataFailure.type) {
              if (forPrint) {
                this.printService.stop();
              }
            }
          })
        )
      )
    )
  );

  fetchDailyFoodChartData$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchDailyFoodChartDataRequest),
      map((action) => {
        return action;
      }),
      mergeMap(({payload, forPrint}) =>
        this.apiService.fetchDailyFoodChartData(payload).pipe(
          map((response) => {
            const {data, message} = response;
            return FetchDailyFoodChartDataSuccess({
              data,
              message,
            });
          }),
          catchError(() => {
            return of(FetchDailyFoodChartDataFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchDailyFoodChartDataSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchDailyFoodChartDataFailure.type) {
              if (forPrint) {
                this.printService.stop();
              }
            }
          })
        )
      )
    )
  );

  fetchWeeklyFoodChartData$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchWeeklyFoodChartDataRequest),
      map((action) => {
        return action;
      }),
      mergeMap(({payload, forPrint}) =>
        this.apiService.fetchWeeklyFoodChartData(payload).pipe(
          map((response) => {
            const {data, message} = response;
            return FetchWeeklyFoodChartDataSuccess({
              data,
              message,
            });
          }),
          catchError(() => {
            return of(FetchWeeklyFoodChartDataFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchWeeklyFoodChartDataSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchWeeklyFoodChartDataFailure.type) {
              if (forPrint) {
                this.printService.stop();
              }
            }
          })
        )
      )
    )
  );

  fetchWeeklyFoodChartTableData$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchWeeklyFoodChartTableDataRequest),
      map((action) => {
        return action;
      }),
      mergeMap(({payload, forPrint}) =>
        this.apiService.fetchWeeklyFoodChartTableData(payload).pipe(
          map((response) => {
            const {data, message} = response;
            return FetchWeeklyFoodChartTableDataSuccess({
              data,
              message,
            });
          }),
          catchError(() => {
            return of(FetchWeeklyFoodChartTableDataFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchWeeklyFoodChartTableDataSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchWeeklyFoodChartTableDataFailure.type) {
              if (forPrint) {
                this.printService.stop();
              }
            }
          })
        )
      )
    )
  );

  fetchBmiChartData$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchBmiChartDataRequest),
      map((action) => {
        return action;
      }),
      mergeMap(({payload, forPrint}) =>
        this.apiService.fetchBmiChartData(payload).pipe(
          map((response) => {
            const {data, message} = response;
            return FetchBmiChartDataSuccess({
              data,
              message,
            });
          }),
          catchError(() => {
            return of(FetchBmiChartDataFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchBmiChartDataSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchBmiChartDataFailure.type) {
              if (forPrint) {
                this.printService.stop();
              }
            }
          })
        )
      )
    )
  );

  fetchBmiChartTableData$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchBmiChartTableDataRequest),
      map((action) => {
        return action;
      }),
      mergeMap(({payload, forPrint}) =>
        this.apiService.fetchBmiChartTableData(payload).pipe(
          map((response) => {
            const {data, message} = response;
            return FetchBmiChartTableDataSuccess({
              data,
              message,
            });
          }),
          catchError(() => {
            return of(FetchBmiChartTableDataFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchBmiChartTableDataSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchBmiChartTableDataFailure.type) {
              if (forPrint) {
                this.printService.stop();
              }
            }
          })
        )
      )
    )
  );

  fetchBmiGoalFilterData$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchBmiGoalFilterDataRequest),
      map((action) => {
        return action;
      }),
      mergeMap(() =>
        this.apiService.fetchBmiGoalFilterData().pipe(
          map((response) => {
            const {data, message} = response;
            return FetchBmiGoalFilterDataSuccess({
              data,
              message,
            });
          }),
          catchError(() => {
            return of(FetchBmiGoalFilterDataFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchBmiGoalFilterDataSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchBmiGoalFilterDataFailure.type) {
              // Code to execute on API Failure Action dispatch
            }
          })
        )
      )
    )
  );

  fetchAdultBmiGoalFilterData$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchAdultBmiGoalFilterDataRequest),
      map((action) => {
        return action;
      }),
      mergeMap(() =>
        this.apiService.fetchAdultBmiGoalFilterData().pipe(
          map((response) => {
            const {data, message} = response;
            return FetchAdultBmiGoalFilterDataSuccess({
              data,
              message,
            });
          }),
          catchError(() => {
            return of(FetchAdultBmiGoalFilterDataFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchAdultBmiGoalFilterDataSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchAdultBmiGoalFilterDataFailure.type) {
              // Code to execute on API Failure Action dispatch
            }
          })
        )
      )
    )
  );

  fetchDailyPAChartData$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchDailyPAChartDataRequest),
      map((action) => {
        return action;
      }),
      mergeMap(({payload, forPrint}) =>
        this.apiService.fetchDailyPhysicalActivityData(payload).pipe(
          map((response) => {
            const {data, message} = response;
            return FetchDailyPAChartDataSuccess({
              data,
              message,
            });
          }),
          catchError(() => {
            return of(FetchDailyPAChartDataFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchDailyPAChartDataSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchDailyPAChartDataFailure.type) {
              if (forPrint) {
                this.printService.stop();
              }
            }
          })
        )
      )
    )
  );

  fetchWeeklyPAData$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchWeeklyPAChartDataRequest),
      map((action) => {
        return action;
      }),
      mergeMap(({payload, forPrint}) =>
        this.apiService.fetchWeeklyPhysicalActivityData(payload).pipe(
          map((response) => {
            const {data, message} = response;
            return FetchWeeklyPAChartDataSuccess({
              data,
              message,
            });
          }),
          catchError(() => {
            return of(FetchWeeklyPAChartDataFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchWeeklyPAChartDataSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchWeeklyPAChartDataFailure.type) {
              if (forPrint) {
                this.printService.stop();
              }
            }
          })
        )
      )
    )
  );

  fetchPATableData$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchPATableDataRequest),
      map((action) => {
        return action;
      }),
      mergeMap(({payload, forPrint}) =>
        this.apiService.fetchPhysicalActivityTableData(payload).pipe(
          map((response) => {
            const {data, message} = response;
            return FetchPATableDataSuccess({
              data,
              message,
            });
          }),
          catchError(() => {
            return of(FetchPATableDataFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchPATableDataSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchPATableDataFailure.type) {
              if (forPrint) {
                this.printService.stop();
              }
            }
          })
        )
      )
    )
  );


  fetchDailySTChartData$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchDailySTChartDataRequest),
      map((action) => {
        return action;
      }),
      mergeMap(({payload, forPrint}) =>
        this.apiService.fetchDailySTData(payload).pipe(
          map((response) => {
            const {data, message} = response;
            return FetchDailySTChartDataSuccess({
              data,
              message,
            });
          }),
          catchError(() => {
            return of(FetchDailySTChartDataFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchDailySTChartDataSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchDailySTChartDataFailure.type) {
              if (forPrint) {
                this.printService.stop();
              }
            }
          })
        )
      )
    )
  );

  fetchWeeklySTData$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchWeeklySTChartDataRequest),
      map((action) => {
        return action;
      }),
      mergeMap(({payload, forPrint}) =>
        this.apiService.fetchWeeklySTData(payload).pipe(
          map((response) => {
            const {data, message} = response;
            return FetchWeeklySTChartDataSuccess({
              data,
              message,
            });
          }),
          catchError(() => {
            return of(FetchWeeklySTChartDataFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchWeeklySTChartDataSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchWeeklySTChartDataFailure.type) {
              if (forPrint) {
                this.printService.stop();
              }
            }
          })
        )
      )
    )
  );

  fetchSTTableData$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchSTTableDataRequest),
      map((action) => {
        return action;
      }),
      mergeMap(({payload, forPrint}) =>
        this.apiService.fetchSTTableData(payload).pipe(
          map((response) => {
            const {data, message} = response;
            return FetchSTTableDataSuccess({
              data,
              message,
            });
          }),
          catchError(() => {
            return of(FetchSTTableDataFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchSTTableDataSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchSTTableDataFailure.type) {
              if (forPrint) {
                this.printService.stop();
              }
            }
          })
        )
      )
    )
  );

  fetchJournalChartData$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchJournalChartDataRequest),
      map((action) => {
        return action;
      }),
      mergeMap(({payload, forPrint}) =>
        this.apiService.fetchJournalChartData(payload).pipe(
          map((response) => {
            const {data, message} = response;
            return FetchJournalChartDataSuccess({
              data,
              message,
            });
          }),
          catchError(() => {
            return of(FetchJournalChartDataFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchJournalChartDataSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchJournalChartDataFailure.type) {
              if (forPrint) {
                this.printService.stop();
              }
            }
          })
        )
      )
    )
  );

  fetchJournalChartTableData$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchJournalChartTableDataRequest),
      map((action) => {
        return action;
      }),
      mergeMap(({payload, forPrint}) =>
        this.apiService.fetchJournalChartTableData(payload).pipe(
          map((response) => {
            const {data, message} = response;
            return FetchJournalChartTableDataSuccess({
              data,
              message,
            });
          }),
          catchError(() => {
            return of(FetchJournalChartTableDataFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchJournalChartTableDataSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchJournalChartTableDataFailure.type) {
              if (forPrint) {
                this.printService.stop();
              }
            }
          })
        )
      )
    )
  );

  constructor(
    private store: Store<fromRoot.State>,
    private apiService: ProgressService,
    private actions: Actions,
    private commonService: CommonService,
    private printService: PrintService,
  ) {
  }
}
